import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  useTheme,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId9 = ['no75', 'no76', 'no77', 'no78', 'no79'];

const 영역9 = [
  {
    id: 1,
    ko: '75. 의사소통',
    info: [
      '정신지체, 시각/청각/언어력소실',
      '정신지체, 시각/청각/언어력 소실이 있는 환자나 인공기도 삽관이 되어있는 환자 등과 의사소통 할 때 보통의 환자보다 많은 시간과 노력이 요구되는 경우 해당된다.',
    ],
    desc: ['해당 없음', '9점'],
  },
  {
    id: 2,
    ko: '76. 정서적 지지',
    info: [
      '환자의 정서적 지지를 위하여 설명과 TV적용, 음악요법 등이 포함되며 기록이 있어야 한다.',
    ],
    desc: ['해당 없음', '6점'],
  },
  {
    id: 3,
    ko: '77. 과도한 정신적 흥분상태',
    info: [
      'severe agitated 환자, delirium으로 불안정한 상태로 도구를 이용한 평가가 있거나, 정신과 전문의의 소견이 있는 환자의 경우에만 해당된다.',
    ],
    desc: ['해당 없음', '12점'],
  },
  {
    id: 4,
    ko: '78. 소아 놀아주기(recreation) 및 관찰',
    info: [
      '12세 이하 아동의 계획적인 놀이요법이나 질문에 답하고 심하게 보채거나 우는 아이를 달래거나 안아주거나 수시로 곁에서 관찰하는 경우에만 해당된다.',
    ],
    desc: ['해당 없음', '6점'],
  },
  {
    id: 5,
    ko: '79.  환자 및 가족상담',
    info: [
      '환자와 가족에게 상담, 면담, 개별교육을 별도로 15분 이상 제공한 경우에 해당된다.',
    ],
    desc: ['해당 없음', '3점: 15분 이상'],
  },
];

const radioId10 = ['no80', 'no81', 'no82', 'no83'];

const 영역10 = [
  {
    id: 1,
    ko: '80. 신환입실 (입원, 전입, 수술 후 입실)',
    info: [
      '입실하는 환자를 위한 인계받기, 침상준비, 침상으로 환자 이동 및 정리 등이 포함된다.',
    ],
    desc: ['해당 없음', '8점'],
  },
  {
    id: 2,
    ko: '81. 퇴실(퇴원, 전출, 수술실)',
    info: [
      '퇴실하는 환자를 위한 행정처리, 설명 및 교육, 인수하기, 환자 준비 등이 포함된다.',
    ],
    desc: ['해당 없음', '6점'],
  },
  {
    id: 3,
    ko: '82. 이동을 위한 준비',
    info: [
      '환자를 chair/wheelchair/commode나 stretcher로 옮기거나 중환자 침대채 이동을 하기 위해 장비와 각종 튜브 등을 정리하는 행위 등이 해당된다.',
      '중환자실 외부(검사실 등)에 갔다가 돌아오는 경우 2회로 산정한다.',
    ],
    desc: ['해당 없음 ', '1회당 3점 :'],
  },
  {
    id: 4,
    ko: '83. 사망환자 간호',
    info: [
      '사망 후 사후처치 등이 포함된다. 사망 후 행정 업무는 "퇴실" 항목에 별도 부여한다.',
    ],
    desc: ['해당 없음', '4점'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum8: number;
  setSum8: (sum8: number) => void;

  sum9: number;
  setSum9: (sum9: number) => void;

  num82: number;
  setNum82: (num82: number) => void;
}

const KPCSCContents6 = (props: Props) => {
  const { palette } = useTheme();

  const {
    disabled,
    setValue,
    getValues,
    setSum9,
    setSum8,
    setNum82,
    register,
  } = props;

  const calculateSumValue9 = () => {
    setSum8(
      radioId9.reduce((acc, cur) => {
        if (cur === 'no76' || cur === 'no78') {
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        } else if (cur === 'no77') {
          const value = Number(getValues(cur)) * 12;
          return value ? acc + value : acc;
        } else if (cur === 'no79') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        } else if (cur === 'no75') {
          const value = Number(getValues(cur)) * 9;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange9 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue9();
  };

  const calculateSumValue10 = () => {
    setSum9(
      radioId10.reduce((acc, cur) => {
        if (cur === 'no82') {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        } else if (cur === 'no80') {
          const value = Number(getValues(cur)) * 8;
          return value ? acc + value : acc;
        } else if (cur === 'no81') {
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        } else if (cur === 'no83') {
          const value = Number(getValues(cur)) * 4;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const [disable82, setDisable82] = useState(false);

  const handleChange10 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue10();
  };

  const handleChange10_82_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no82_1', 0);
    setNum82(0);
    setDisable82(true);
    calculateSumValue10();
  };

  const handleChange10_82_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no82_1', 1);
    setNum82(3);
    setDisable82(false);
    calculateSumValue10();
  };

  useEffect(() => {
    calculateSumValue9();
    calculateSumValue10();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 정서적 지지 및 상담/교육" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역9.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역9.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역9.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId9[content.id - 1]}
                      defaultValue={Number(getValues(radioId9[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        if (point.includes('no')) {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                                height: '43px',
                              }}
                            ></TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId9[content.id - 1]}
                                  value={i}
                                  onChange={handleChange9}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역9.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => (
                        <TableRow
                          sx={{
                            lineHeight: '42px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}>{v}</Box>
                        </TableRow>
                      ))}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 입퇴실" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '-30px' }}>
          <TableBody>
            {영역10.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역10.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역10.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId10[content.id - 1]}
                      defaultValue={Number(
                        getValues(radioId10[content.id - 1])
                      )}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no82'}
                                  value={i}
                                  onChange={handleChange10_82_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no82'}
                                  value={i}
                                  onChange={handleChange10_82_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId10[content.id - 1]}
                                value={i}
                                onChange={handleChange10}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역10.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회당 3점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable82 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no82_1', {
                                    onChange: e => {
                                      setValue('no82_1', e.target.value);
                                      setNum82(Number(e.target.value) * 3);
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>{v}</Box>
                            </TableRow>
                          );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCContents6;
